<template>
    <footer class="bg-black p-4 lg:py-16">
      <div class="container mx-auto text-white grid grid-cols-1 md:grid-cols-2">
        <div class="attrib mb-8 md:mb-0">
          <p class="mb-6 font-medium">Copyright © Angela Sielski 2024</p>
          <p class="mb-6">Keller Williams Realty, Inc., a franchise company, is an Equal Opportunity Employer and
            supports the Fair
            Housing Act. Each Keller Williams office is independently owned and operated.</p>
          <p>Photo by <a
              href="https://unsplash.com/@fromitaly?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Francesca
              Tosolini</a> on <a
              href="https://unsplash.com">Unsplash</a>
          </p>
          <p>Icons made by <a href="https://www.flaticon.com/authors/prosymbols" title="Prosymbols">Prosymbols</a> from
            <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
          <p>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a>
            from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
          <p class="mb-6">Icons made by <a href="https://remixicon.com/">Remix Icon</a></p>
          <p>Portions © Zillow, Inc., 2006-2016. Use is subject to <a href="https://www.zillow.com/corp/Terms.htm">Terms
            of Use</a></p>
        </div>
        <div class="attrib flex flex-col items-start md:items-end text-left md:text-right">

          <Logo class="w-32 h-auto mb-12" />

          <p class="mb-10"><strong>Keller Williams Elite, Realtors</strong><br>
            License #0458706<br>
            Office: <a class="no-underline font-normal" href="tel:1-732-549-1998">(732) 549-1998</a><br>
            481 Memorial Parkway<br>
            Metuchen, NJ 08840</p>

          <p><strong>Angela Sielski</strong><br>
            Keller Williams Elite, Realtors<br>
            License #1755327</p>

        </div>
      </div>
    </footer>
</template>

<script>

import Logo from '@/components/Logo.vue'

export default {
  name: 'Footer',
  components: { Logo }
}
</script>

<style scoped lang="scss">
  footer p {
    color: #ccc;
  }
  footer a {
    color: #eee;
  }
  footer a:hover {
    color: #fff;
    text-decoration: underline;
  }
</style>
